
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './automation.json';

const Automation = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="AI automation, job displacement, and technology vocabulary. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="Automation"
            image="/Images/selfcheckout.webp"
            seoTitle="Free English Lesson Plans: Automation"
            seoDescription="AI automation, job displacement, and technology vocabulary. B2/C1 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Automation;


